"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toPodcastVisualSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toPodcastVisualSlice = function (data, logger) {
    var podcast = logger.required(field_groups_1.toPodcast(data.primary, logger));
    var title = logger.required(fields_1.toText(data.primary.title));
    var date = logger.required(fields_1.toTimestamp(data.primary.date));
    var podcastImage = logger.required(field_groups_1.toImageWithCredits(data.primary, logger));
    if (!(podcast && title && date && podcastImage)) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toAnchoredSlice(data, types_1.SliceType.PodcastVisual)), { title: title,
        date: date,
        podcast: podcast,
        podcastImage: podcastImage }));
};
exports.toPodcastVisualSlice = toPodcastVisualSlice;
//# sourceMappingURL=podcast-visual-slice.js.map